import { render, staticRenderFns } from "./shortcutMenu.vue?vue&type=template&id=5dacc374&scoped=true"
import script from "./shortcutMenu.vue?vue&type=script&lang=js"
export * from "./shortcutMenu.vue?vue&type=script&lang=js"
import style0 from "./shortcutMenu.vue?vue&type=style&index=0&id=5dacc374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dacc374",
  null
  
)

export default component.exports